module.exports = __webpack_public_path__ + "static/media/new_header.72af6594.png";